import React from "react";

import Box from "@mui/material/Box";
import MuiSlider from "@mui/material/Slider";

import { getStep } from "../helper";
import { numberWithUnit } from "../../helper";

import InputNumeric from "../../Numeric/InputNumeric";

type TTupel = [number, number];
interface IInputNumericRangeSlider {
  min: number;
  max: number;
  value: TTupel;
  step?: number;
  unit?: string;
  hideEdges?: boolean;
  disabled?: boolean;
  disabledInput?: boolean;
  onChangeHandler: any;
}

const InputNumericRangeSlider: React.FC<IInputNumericRangeSlider> = ({
  value = [10, 90],
  min = 0,
  max = 100,
  step,
  hideEdges = false,
  disabled = false,
  disabledInput = false,
  onChangeHandler = (e: any) => e,
  unit,
}) => {
  const [localMin, setLocalMin] = React.useState(String(value[0]));
  const [localMax, setLocalMax] = React.useState(String(value[1]));

  React.useEffect(() => {
    setLocalMin(String(value[0]));
    setLocalMax(String(value[1]));
  }, [value]);

  const setLocal = (value: [number, number]) => {
    setLocalMin(String(value[0]));
    setLocalMax(String(value[1]));
  };

  const handleBlur = (type: string, newValue?: number) => {
    let val =
      typeof newValue === "number"
        ? newValue
        : type === "min"
          ? Number(localMin)
          : Number(localMax);
    let [currentMin, currentMax] = value;

    if (isNaN(val)) val = type === "min" ? currentMin : currentMax;
    val = Math.max(min, Math.min(max, val));

    let nextRange = [...value];
    if (type === "min") {
      nextRange = [Math.min(val, currentMax), currentMax];
    } else {
      nextRange = [currentMin, Math.max(val, currentMin)];
    }

    onChangeHandler(nextRange);
  };

  if (min >= max) {
    return <span>{numberWithUnit({ value: value[0], unit })}</span>;
  }

  return (
    <>
      <Box
        sx={{
          typography: "body2",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
        }}
      >
        <InputNumeric
          prefix="von"
          value={localMin}
          unit={unit}
          disabled={disabledInput}
          submitHandler={(v: string) => {
            setLocalMin(v);
            handleBlur("min", v.length === 0 ? 0 : parseInt(v));
          }}
        />
        <InputNumeric
          prefix="bis"
          value={localMax}
          unit={unit}
          disabled={disabledInput}
          submitHandler={(v: string) => {
            setLocalMin(v);
            handleBlur("max", v.length === 0 ? 0 : parseInt(v));
          }}
        />
      </Box>
      <MuiSlider
        data-testid="input-range-slider"
        marks
        min={min}
        max={max}
        value={[parseInt(localMin), parseInt(localMax)]}
        step={step || getStep(max - min)}
        onChange={(e, newValue) => {
          setLocal(newValue as [number, number]);
        }}
        onChangeCommitted={(e, newValue) => onChangeHandler(newValue)}
        getAriaLabel={() => "Price range"}
      />
      {!hideEdges && (
        <Box
          sx={{
            typography: "body1",
            display: "flex",
            justifyContent: "space-between",
            mt: -2,
          }}
        >
          <span>{numberWithUnit({ value: min, unit })}</span>
          <span>{numberWithUnit({ value: max, unit })}</span>
        </Box>
      )}
    </>
  );
};
export default InputNumericRangeSlider;
